import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { useQueryParams, BooleanParam } from 'use-query-params'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'
import { DEDICATED_LANE_SEARCH_PAGE_SCROLL_Y } from '../../pages/dedicated-lanes/constants'
import { DedicatedLanesOfferCardInfo } from './DedicatedLanesOfferCardInfo'
import { DedicatedLanesOfferCardInfoMobile } from './DedicatedLanesOfferCardInfoMobile'
import { getDedicatedLaneInfo } from './utils'

export interface ILaneOfferCardProps {
  dedicatedLane: DedicatedLanesResponse
}

export const DedicatedLanesOfferCard: FC<ILaneOfferCardProps> = ({ dedicatedLane }) => {
  const history = useHistory()
  const { id } = getDedicatedLaneInfo(dedicatedLane) || {}
  const { isMobile } = useBreakpointContext()
  const [{ mobileApp }] = useQueryParams({ mobileApp: BooleanParam })

  const openOfferDetailsHandler = () => {
    if (mobileApp) {
      localStorage.setItem(DEDICATED_LANE_SEARCH_PAGE_SCROLL_Y, `${window.scrollY}`)
    }
    const mobileAppQueryParam = mobileApp ? '?mobileApp=1' : ''
    history.push(`/dedicated-lanes/lane/${id}${mobileAppQueryParam}`)
  }

  return (
    <div>
      {!isMobile ? (
        <DedicatedLanesOfferCardInfo
          dedicatedLane={dedicatedLane}
          onClick={openOfferDetailsHandler}
        />
      ) : (
        <DedicatedLanesOfferCardInfoMobile
          dedicatedLane={dedicatedLane}
          onClick={openOfferDetailsHandler}
        />
      )}
    </div>
  )
}
